import { useEffect, useState } from 'react';
import { estaOnline, suscribirRed } from '../almacen/red.js';
import { pendientesOutbox, suscribirOutbox } from '../almacen/outbox.js';

export function useRed(): boolean {
  const [online, setOnline] = useState(estaOnline());
  useEffect(() => suscribirRed(setOnline), []);
  return online;
}

export function usePendientes(): number {
  const [n, setN] = useState(0);
  useEffect(() => {
    const actualizar = () => void pendientesOutbox().then(setN);
    actualizar();
    const a = suscribirOutbox(actualizar);
    const b = suscribirRed(actualizar);
    return () => {
      a();
      b();
    };
  }, []);
  return n;
}
